<template>
  <section class="relative">
    <div class="dark-blue-shade section-large">
      <div class="text-with-image container">
        <div class="narrow-text">
        <h2>Conference sub-themes</h2>

        <p>We have outlined six sub-themes for the conference and ask contributors to align their sessions to one or more of these sub-themes (NB. you will be asked to indicate which sub-theme(s) your contribution aligns to in the Call for Contributions questionnaire). Collaboration, community, and digitally-enhanced learning are at the heart of learning and teaching at Manchester Met and as such may be reflected in proposals aligned to any of the sub-themes below.</p>

        </div>
        <div class="text-with-image-img">
          <img src="../assets/topics-two.svg" alt="">
        </div>
      </div>

    <div class="text-with-image container mtm">
    <!-- ROW ONE -->
      <div class="about-theme theme">
        <div class="about-theme-icon">
          <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.46 31.21">
            <polyline points="9.42 11.64 15.21 16 19.21 15" style="fill: none; stroke: #303030; stroke-miterlimit: 10; stroke-width: 2px;"/>
            <polyline points="5.21 12 2.21 13 1.21 17" style="fill: none; stroke: #303030; stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
            <polyline points="11.21 20 14.21 23 14.21 29" style="fill: none; stroke: #303030; stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
            <circle cx="10.71" cy="4.5" r="3.5" style="fill: none; stroke: #303030; stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
            <line x1="5.21" y1="31" x2="10.22" y2="7.97" style="fill: none; stroke: #303030; stroke-miterlimit: 10; stroke-width: 2px;"/>
          </svg>
        </div>
        <div>
          <p>Active learning for student engagement.</p>
        </div>
      </div>

    <!-- ROW TWO -->
      <div class="about-theme theme">
        <div class="about-theme-icon">
          <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.3 30.72">
            <polygon points="16.15 2.26 20.47 11.03 30.15 12.43 23.15 19.25 24.8 28.89 16.15 24.34 7.5 28.89 9.15 19.25 2.15 12.43 11.82 11.03 16.15 2.26" style="fill: none; stroke: #303030; stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
          </svg>
        </div>
        <div>
          <p>Bringing inclusive learning and curricula to life (e.g., addressing awarding gaps, digital accessibility).</p>
        </div>
      </div>

      <div class="about-theme theme">
        <div class="about-theme-icon">
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><line x1="1" y1="16" x2="3" y2="16" style="fill: none; stroke: #303030; stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/><line x1="5.4" y1="5.4" x2="6.8" y2="6.8" style="fill: none; stroke: #303030; stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/><line x1="16" y1="1" x2="16" y2="3" style="fill: none; stroke: #303030; stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/><line x1="26.6" y1="5.4" x2="25.2" y2="6.8" style="fill: none; stroke: #303030; stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/><line x1="31" y1="16" x2="29" y2="16" style="fill: none; stroke: #303030; stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/><line x1="26.6" y1="26.6" x2="25.2" y2="25.2" style="fill: none; stroke: #303030; stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/><line x1="16" y1="31" x2="16" y2="29" style="fill: none; stroke: #303030; stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/><line x1="5.4" y1="26.6" x2="6.8" y2="25.2" style="fill: none; stroke: #303030; stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/><circle cx="16" cy="16" r="8" style="fill: none; stroke: #303030; stroke-linecap: squarestroke-miterlimit: 10; stroke-width: 2px;"/></svg>  
        </div>
        <div>
          <p>Authentic learning and assessment.</p>
        </div>
      </div>
    </div>


    <div class="text-with-image container mtm-icons">
      <div class="about-theme theme">
        <div class="about-theme-icon">
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
              <line x1="1" y1="16" x2="3" y2="16" style="fill: none; stroke: #303030; stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
              <line x1="5.39" y1="5.39" x2="6.81" y2="6.81" style="fill: none; stroke: #303030; stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
              <line x1="16" y1="1" x2="16" y2="3" style="fill: none; stroke: #303030; stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
              <line x1="26.61" y1="5.39" x2="25.19" y2="6.81" style="fill: none; stroke: #303030; stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
              <line x1="31" y1="16" x2="29" y2="16" style="fill: none; stroke: #303030; stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
              <path d="m25,16c0-4.97-4.03-9-9-9s-9,4.03-9,9c0,3.53,2.04,6.58,5,8.05v6.95h8v-6.95c2.96-1.47,5-4.52,5-8.05Z" style="fill: none; stroke: #303030; stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
              <line x1="12" y1="27" x2="20" y2="27" style="fill: none; stroke: #303030; stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
            </svg>
        </div>
        <div>
          <p>Creative and innovative pedagogies.</p>
        </div>
      </div>
      <div class="about-theme theme">
        <div class="about-theme-icon">
         <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 26">
  <polyline points="29 1 22 1 22 7 15 7 15 13 8 13 8 19 1 19 1 25" style="fill: none; stroke: #303030; stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
</svg>
        </div>
        <div>
          <p>Supporting student futures and careers.</p>
        </div>
      </div>
      <div class="about-theme theme">
        <div class="about-theme-icon" >
         <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.59 30.62">
  <path d="m8.41,9.61C14.31,3.71,29.41,1.21,29.41,1.21c0,0-2,14.6-8.4,21-6.9,6.9-14.9,2.3-14.9,2.3,0,0-4.7-7.9,2.3-14.9Z" style="fill: none; stroke: #303030; stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
  <line x1="16.41" y1="14.21" x2="1.41" y2="29.21" style="fill: none; stroke: #303030; stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
</svg>
        </div>
        <div>
          <p>Education for Sustainable Development (ESD) and carbon literacy.</p>
        </div>
      </div>        
    </div>
  </div>
    <div class="about-divider">
      <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
      <!-- <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" class="shape-fill"></path> -->
          <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
        <path d="M1200 120L0 16.48 0 0 1200 0 1200 120z" class="shape-fill"></path>
    </svg>
      </svg>
    </div> 
    
  </section>
</template>


